(function () {
    'use strict';

    var mainPalette = ['#00aeef', '#b21dac', '#8dc63f', '#ffb100', '#dd0014', '#8b959b'],
        extPalette1 = ['#5c0a69', '#b21dac', '#f7bff2', '#00409e', '#00aeef', '#baeaf9', '#21572b', '#8dc63f', '#e0eecb', '#ed721e', '#ffb100', '#ffe5ad', '#761114', '#dd0014', '#ffc9cc'],
        extPalette2 = ['#b21dac', '#00aeef', '#8dc63f', '#dd0014', '#ffb100', '#820c8e', '#0073c2', '#218535', '#ff9305', '#a30000', '#5c0a69', '#00409e', '#21572b', '#ed721e', '#761114'];

    angular.module('settings', [])
        .constant('SETTINGS', (function () {

            var defaults = {
                DEFAULT_STATE: 'app.module.dashboard.default',
                DEFAULT_URL: '/reports/login',
                HTML5_MODE: true,
                AFTER_AUTH_PATH: 'dashboard', // for use with $location.path('<insert_path>')
                AFTER_AUTH_STATE: 'app.module.reports.default', // for use with $state.go(<insert_state>)
                LOGIN_STATE: 'app.module.login',
                DEFAULT_BODY_CLASS: 'page-header-fixed page-sidebar-closed-hide-logo page-md',
                IMAGES: {
                    NAV_LOGO: '/assets/images/nav-logo.png',
                    LOGIN_LOGO: '/assets/images/login-logo.png'
                },
                AUTH: {
                    TYPE: 'token', // [ token | none ]
                    LOGIN_URL: '/login',
                    FORGOT_PASSWORD: false
                },
                API: {
                    URL: '/set/api/url'
                },
				ALLOW_EDITING_CONTENT: true,
                PALETTE: mainPalette,
                PALETTE_EXT1: extPalette1,
                PALETTE_EXT2: extPalette2,
                CHARTS: {
                    TEXT: {
                        COLOR: '#333333' // default text colour
                    },
                    SOURCE: 'Nielsen',
                    PALETTE: extPalette2,
                    LEGEND: {
                        SWITCHABLE: false
                    },
                    PRECISION: 1,
                    DOLLARPRECISION: 2
                },
                FONT_FAMILY: 'Open Sans' // NB this is not used in CSS
            };

            // Overwrite defaults with customisations
            return angular.merge({}, defaults, SETTINGS);
        })())
    ;
})();
